import { render, staticRenderFns } from "./CascaderOption.vue?vue&type=template&id=55080452&scoped=true&"
import script from "./CascaderOption.vue?vue&type=script&lang=js&"
export * from "./CascaderOption.vue?vue&type=script&lang=js&"
import style0 from "./CascaderOption.vue?vue&type=style&index=0&id=55080452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55080452",
  null
  
)

export default component.exports